<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/eRlyxK/tc-custom/9781608465361.jpg?1725275607840" alt="This image is the cover for the book Bananeras"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Bananeras
      </h1>
      <p class="bookDescription body article font2">
        <b>This story of Latina labor organizers is “a vital accounting of the struggles still being waged” (Margaret Randall, author of <i>When I Look Into the Mirror and See You: Women, Terror, and Resistance</i>).</b><br/><br/>Women who pick and pack bananas in Latin America have organized themselves and gained increasing control over their unions, their workplaces, and their lives—while making gender equity central in their effort. Highly accessible and narrative in style, and written by the author of the award-winning <i>Buy American: The Untold Story of Economic Nationalism</i>, <i>Bananeras </i>recounts the history and growth of this vital movement and shows how Latin American woman workers are shaping and broadly reimagining the possibilities of international labor solidarity.<br/><br/><i>Includes photographs.</i><br/><br/>“A wonderful book—entertaining, enlightening, and inspiring. A unique blend of personal stories grounded in a solid analysis of the globalization of the banana economy, the rise of a regional banana workers movement, and the intense internal struggle for gender justice within Latin America’s historically male-dominated unions.” —Stephen Coats, former Executive Director, US Labor Education in the Americas Project
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Dana Frank
      </h2>
      
      <p class="authorDescription body article">Dana Frank is a professor of History at the University of California, Santa Cruz, and the author of the award winning Buy American. She has published essays in the Washington Post, SF Chronicle, San Jose Mercury News and The Nation.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Haymarket Books
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?3a52ab85